import * as Styled from '../activity-builder-skeleton.style';

const LessonSkeletonPresent = () => (
  <Styled.ActivityBuilderSkeleton>
    <Styled.ActivityBuilderSkeletonRow $paddingTop={56}>
      <Styled.ActivityBuilderSkeletonSlideRow>
        <Styled.ActivityBuilderSkeletonSlide />
      </Styled.ActivityBuilderSkeletonSlideRow>
    </Styled.ActivityBuilderSkeletonRow>
  </Styled.ActivityBuilderSkeleton>
);

export default LessonSkeletonPresent;
